module.exports = __webpack_public_path__ + "static/media/hingeFrameCap.501dcc1f.png";